import http from "../httpService";
import { apiUrl } from "../../../config.js";
const apiEndpoint = apiUrl + "/sales/sales-order/";

export function getSalesOrders(giStatus, reserveStatus) {
  return http.get(apiEndpoint + "data/" + giStatus + "/" + reserveStatus);
}

export function getNonOpSalesOrders(giStatus, reserveStatus) {
  return http.get(apiEndpoint + "no-op/" + giStatus + "/" + reserveStatus);
}

export function getSalesOrder(salesOrderID = 0, passAuth = "false") {
  return http.get(
    apiEndpoint + "sales-order-detail/" + salesOrderID + "/" + passAuth
  );
}

export function getSalesOrderItems(salesOrderID, itemType = "item") {
  return http.get(
    apiEndpoint + "sales-order-items/" + salesOrderID + "/" + itemType
  );
}

export function cancelSalesOrder(salesOrderID = 0) {
  return http.delete(apiEndpoint + "sales-order/" + salesOrderID);
}

export function saveSalesOrder(salesOrder) {
  return http.post(apiEndpoint, salesOrder);
}

export function getPendingGISalesOrder() {
  return http.get(apiEndpoint + "pending-gi-so");
}
